const messages = {
  payoutsDescription: "List of paid out BS+ items.",
  paidOut: "paid out",
  makeChoice: "Vyberte si zde",
  seeAll: "Zobrazit vše",
  clear: "Vymazat",
  back: "Zpět",
  save: "Uložit",
  close: "Zavřít",
  of: "z",
  to: "do",
  copyrights: "© {date} Bridgestone Solutions. Všechna práva vyhrazena.",
  pageNotFound: "Stránka nebyla nalezena",
  accessDenied: "Přístup odepřen",
  search: "Hledat",
  year: "Rok",
  buttons: {
    loading: "Načítání...",
    export: "Exportovat",
    delete: "Smazat",
    save: "Uložit",
    cancel: "Zrušit",
    next: "Další",
    back: "Zpět",
    skip: "Přeskočit",
    send: "Odeslat",
    pointsList: "Seznam bodů",
    clear: "Vymazat",
    readNow: "čtěte nyní",
    more: "Více",
    close: "Zavřít",
    reportError: "Nahlásit chybu",
    accept: "Přijmout",
    download: "Stáhnout",
    downloadAll: "Stáhnout vše",
    selectAll: "Vybrat vše",
    deselectAll: "Zrušit výběr",
    downloadSelection: "Stáhnout vybrané",
    dealerInfoDownload: "STÁHNOUT",
    toTheBasket: "Do košíku",
    toOrderDelivery: "Pokračovat na doručovací adresu",
    discover: "Objevit",
    newAddress: "Vytvořit novou doručovací adresu",
    selectAddressBtn: "Vybrat doručovací adresu",
    toOrderSummary: "K přehledu objednávky",
    placeOrder: "Závazná objednávka",
    toDashboard: "Na domovskou stránku",
    newOrder: "Nová objednávka",
    userOrders: "K vašim objednávkám",
    toSearch: "Hledat",
    select: "Vybrat",
    moreCustomerNumbers: "+ PŘIDAT DALŠÍ ČÍSLA ZÁKAZNÍKŮ",
    loadMore: "Načíst více",
    toStaffDashboard: "Na panel",
    toQuiz: "Ke kvízu",
    vouchers: "Poukazy",
    exchangeVoucher: "Uplatnit kód poukazu",
    confirm: "Potvrdit",
    sharePoints: "Sdílet body",
    create: "Vytvořit",
    update: "Aktualizovat",
    toBDrive: "Do B-Drive",
    preview: "Náhled",
    clickHere: "Zobrazit podrobnosti",
    setFilters: "Nastavte prosím <b>maximálně jeden filtr na sloupec</b>",
    all: "Vše",
  },
  tooltips: {
    info: "Potřebujete pomoc? +420 771 239 989",
  },
  confirmation: {
    header: "Vyžadováno potvrzení",
    message: "Opravdu chcete tuto položku smazat?",
  },
  nav: {
    consents: "Souhlasy",
    dashboard: "Domů",
    accountDashboard: "Přehled",
    account: "Můj Profil",
    mailbox: "VAŠE ZPRÁVY",
    singleMailbox: "Zprávy",
    stammdaten: "Základní data",
    news_feeds: "Zprávy",
    pointsOverview: "Přehled bodů",
    rewardsOverview: "Přehled bodů",
    about: "O BS Plus",
    service_number: "Kontakt na servis",
    shop: "Obchod s odměnami",
    salesPromotions: "Prodejní akce",
    promotions: "Můj účet",
    shopCategory: "Obchod s odměnami",
    productDetails: "Detaily produktu",
    userOrders: "Uživatelské objednávky",
    shoppingCart: "Nákupní košík",
    orderDelivery: "Doručovací adresa",
    orderSummary: "Přehled objednávky",
    orderComplete: "Objednávka dokončena",
    text_page: "Statická stránka",
    staff: "Servisní panel",
    onlineTrainings: "Online školení",
    trainings: "Školení",
    training: "Školení",
    trainingForm: "Formulář školení",
    staffVouchers: "Poukazy",
    wholesalerVouchers: "Poukazy",
    brochure_prices: "Ceníky a brožury",
    investment: "Podpora investic",
    media: "Média",
    medias: "Média",
    contact_service: "Kontaktní údaje a servis",
    productInfo: "INFORMACE O PRODUKTU",
    bDrive: "Obrázky produktů",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Podmínky účasti",
    first_stop: "Záruka na pneumatiky Bridgestone",
    bonusUhrd: "Bonus UHRD",
    bonusGoals: "Nákupní cíle",
    bonusAwans: "BONUS ZA POSTUP",
    payouts: "Payouts",
    portalPromotions: "Akce",
    portalPromotionDetail: "Detail akce",
  },
  breadcrumbs: {
    dashboard: "Domů",
    accountDashboard: "Přehled",
    account: "Můj Profil",
    mailbox: "VAŠE ZPRÁVY",
    singleMailbox: "Zprávy",
    stammdaten: "Základní data",
    news_feeds: "Zprávy",
    pointsOverview: "Přehled bodů",
    rewardsOverview: "Přehled bodů",
    about: "O BS Plus",
    service_number: "Kontakt na servis",
    shop: "Obchod s odměnami",
    salesPromotions: "Prodejní akce",
    promotions: "Můj účet",
    shopCategory: "Obchod s odměnami",
    productDetails: "Detaily produktu",
    userOrders: "Uživatelské objednávky",
    shoppingCart: "Nákupní košík",
    orderDelivery: "Doručovací adresa",
    orderSummary: "Přehled objednávky",
    orderComplete: "Objednávka dokončena",
    staff: "Servisní panel",
    onlineTrainings: "Online školení",
    trainings: "Školení",
    training: "Školení",
    trainingForm: "Formulář školení",
    staffVouchers: "Poukazy",
    wholesalerVouchers: "Poukazy",
    brochure_prices: "Ceníky a brožury",
    investment: "Podpora investic",
    media: "Média",
    medias: "Média",
    contact_service: "Kontaktní údaje a servis",
    productInfo: "INFORMACE O PRODUKTU",
    bDrive: "Obrázky produktů",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Podmínky účasti",
    first_stop: "Záruka na pneumatiky Bridgestone",
    payouts: "Payouts",
    portalPromotions: "Akce",
    portalPromotionDetail: "Detail akce",
  },
  menu: {
    account: "Můj Profil",
    plus: 'O Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Podpora prodeje",
    mailbox: "VAŠE ZPRÁVY",
    about: "O BS Plus",
    trainingAndCourses: "Školení a kurzy",
    externalTraining: "Externí školení",
    productInfo: "Informace o produktu",
    productBrochures: "Produktové brožury",
    priceLists: "Ceníky",
    price: "Cena",
    complaintForm: "Formulář stížnosti",
    sales_support: "Podpora prodeje",
    contact_service: "Kontaktní údaje a servis",
    logOut: "Odhlásit se",
    news: "Novinky",
    news_feeds: "Zprávy",
    service_number: "Kontakt na servis",
    salesPromotions: "Prodejní akce",
    shop: "Obchod",
    onlineTrainings: "Online školení",
    trainings: "Školení",
    brochure_prices: "Ceníky a brožury",
    media: "Média",
    medias: "Média",
    stammdaten: "Základní data",
    preislisten: "Ceníky",
  },
  validation: {
    requiredField: "Povinné pole",
  },
  sortBy: {
    default: "Řadit podle",
    desc: "Řadit podle: Nejnovější",
    asc: "Řadit podle: Nejstarší",
    name: "Název",
    date: "Datum",
    choiceBy: "Řazení",
  },
  month: {
    1: "leden",
    2: "únor",
    3: "březen",
    4: "duben",
    5: "květen",
    6: "červen",
    7: "červenec",
    8: "srpen",
    9: "září",
    10: "říjen",
    11: "listopad",
    12: "prosinec"
  },
};


export default {
  messages,
};
